module.exports = __webpack_public_path__ + "img/63.7.Chla.c86ad1d9.png";